import store from '../store'

import customRoutes from './module/custom';			// 自定义配置模块
import basicRoutes from './module/basic.js';		// 基础管理
import systemRoutes from './module/system.js';		// 系统管理
import qualityRoutes from './module/quality.js';	// 质检接驳
import repairRoutes from './module/repair.js';
import purchaseRoutes from './module/purchase.js';	// 采购相关
import productRoutes from './module/product.js';	// 商品相关
import storageRoutes from './module/storage.js';	// 库存相关
import salesRoutes from './module/sales.js';		// 销售相关
import financeRoutes from './module/finance.js';		// 财务相关

const routes = [
	{
		path: '',
		name: 'home',
		meta: {
			authFree: true
		},
		component: () => import('@/pages/home/index')
	}, {
		path: 'article/:article_type',
		name: 'article_list',
		meta: {
			authFree: true
		},
		props: route => route.params,
		component: () => import('@/pages/content/article_list')
	}, {
		path: 'article/:article_type/detail/:id',
		name: 'article_detail',
		meta: {
			authFree: true
		},
		props: route => route.params,
		component: () => import('@/pages/content/article_detail')
	}, {
		path: 'custom',
		name: 'p_custom',
		component: {
			render: h => h('router-view')
		},
		children: [
			...customRoutes
		]
	}, {
		path: 'basic',
		name: 'p_basic',
		component: {
			render: h => h('router-view')
		},
		children: [
			...basicRoutes
		]
	}, {
		path: 'system',
		name: 'p_system',
		component: {
			render: h => h('router-view')
		},
		children: [
			...systemRoutes
		]
	}, {
		path: 'quality',
		name: 'p_quality',
		component: {
			render: h => h('router-view')
		},
		children: [
			...qualityRoutes
		]
	},
	{
		path: 'repair',
		name: 'p_repair',
		component: {
			render: h => h('router-view')
		},
		children: [
			...repairRoutes
		]
	}, {
		path: 'purchase',
		name: 'p_purchase',
		component: {
			render: h => h('router-view')
		},
		children: [
			...purchaseRoutes
		]
	}, {
		path: 'product',
		name: 'p_product',
		component: {
			render: h => h('router-view')
		},
		children: [
			...productRoutes
		]
	}, {
		path: 'sales',
		name: 'p_sales',
		component: {
			render: h => h('router-view')
		},
		children: [
			...salesRoutes
		]
	}, {
		path: 'stock',
		name: 'p_storage',
		component: {
			render: h => h('router-view')
		},
		children: [
			...storageRoutes
		]
	}, {
		path: 'finance',
		name: 'p_finance',
		component: {
			render: h => h('router-view')
		},
		children: [
			...financeRoutes
		]
	}
];

export default [{
	path: '/login',
	name: 'login',
	meta: {
		loginFree: true
	},
	props: route => route.query,
	component: () => import('@/pages/login/index'),
	beforeEnter: (to, from, next) => {
		if (store.state.session) {
			next('/');
		} else {
			next();
		}
	}
}, {
	path: '/',
	component: () => import('@/pages/index'),
	children: routes
}, {
	path: '/print',
	component: () => import('@/pages/home/print')
}, {
	path: '/doc',
	props: route => route.query,
	component: () => import('@/pages/home/doc')
}, {
	path: '/comp',
	meta: {
		loginFree: true
	},
	component: () => import('@/pages/api/index')
}, {
	path: '*',
	redirect: '/'
}];
